function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "mastercard"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_7805",
  "data-name": "Path 7805",
  d: "M218.291,109.146a8.346,8.346,0,1,1-16.691,0h0a8.346,8.346,0,1,1,16.691,0Z",
  transform: "translate(-190.473 -100.8)",
  fill: "#ffb600"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7806",
  "data-name": "Path 7806",
  d: "M209.946,100.8a8.368,8.368,0,0,1,8.345,8.346h0a8.346,8.346,0,1,1-16.691,0",
  transform: "translate(-190.473 -100.8)",
  fill: "#f7981d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7807",
  "data-name": "Path 7807",
  d: "M352.8,100.8a8.368,8.368,0,0,1,8.346,8.346h0a8.339,8.339,0,0,1-8.346,8.346",
  transform: "translate(-333.327 -100.8)",
  fill: "#ff8500"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7808",
  "data-name": "Path 7808",
  d: "M8.257,100.8a8.346,8.346,0,0,0,.088,16.692,8.442,8.442,0,0,0,5.608-2.164h0a7.934,7.934,0,0,0,.839-.883H13.07a10.187,10.187,0,0,1-.618-.839h2.958a5.658,5.658,0,0,0,.486-.883h-3.93a5.264,5.264,0,0,1-.353-.883h4.592a8.769,8.769,0,0,0,.442-2.65,11.4,11.4,0,0,0-.177-1.766H11.348a6.456,6.456,0,0,1,.221-.883h4.592a5.262,5.262,0,0,0-.353-.883H11.922a8.756,8.756,0,0,1,.486-.883h2.958a4.2,4.2,0,0,0-.662-.883H13.07a7.524,7.524,0,0,1,.839-.839A8.148,8.148,0,0,0,8.3,100.888C8.3,100.8,8.3,100.8,8.257,100.8Z",
  transform: "translate(0 -100.8)",
  fill: "#ff5050"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7809",
  "data-name": "Path 7809",
  d: "M0,110.658A8.339,8.339,0,0,0,8.346,119a8.442,8.442,0,0,0,5.608-2.164h0a7.94,7.94,0,0,0,.839-.883H13.07a10.193,10.193,0,0,1-.618-.839h2.958a5.657,5.657,0,0,0,.486-.883h-3.93a5.264,5.264,0,0,1-.353-.883h4.592a8.77,8.77,0,0,0,.442-2.65,11.4,11.4,0,0,0-.177-1.766H11.348a6.458,6.458,0,0,1,.221-.883h4.592a5.263,5.263,0,0,0-.353-.883H11.922a8.756,8.756,0,0,1,.486-.883h2.958a4.2,4.2,0,0,0-.662-.883H13.07a7.526,7.526,0,0,1,.839-.839A8.148,8.148,0,0,0,8.3,102.4H8.257",
  transform: "translate(0 -102.312)",
  fill: "#e52836"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7810",
  "data-name": "Path 7810",
  d: "M149.688,119a8.442,8.442,0,0,0,5.608-2.164h0a7.943,7.943,0,0,0,.839-.883h-1.722a10.188,10.188,0,0,1-.618-.839h2.958a5.654,5.654,0,0,0,.486-.883h-3.93a5.267,5.267,0,0,1-.353-.883h4.592a8.77,8.77,0,0,0,.442-2.65,11.4,11.4,0,0,0-.177-1.766h-5.122a6.455,6.455,0,0,1,.221-.883H157.5a5.271,5.271,0,0,0-.353-.883h-3.886a8.765,8.765,0,0,1,.486-.883h2.958a4.2,4.2,0,0,0-.662-.883h-1.634a7.525,7.525,0,0,1,.839-.839,8.148,8.148,0,0,0-5.608-2.164H149.6",
  transform: "translate(-141.343 -102.312)",
  fill: "#cb2026"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_8628",
  "data-name": "Group 8628",
  transform: "translate(0.795 6.182)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_7811",
  "data-name": "Path 7811",
  d: "M182.881,223.886l.132-.751a1.912,1.912,0,0,1-.221.044c-.309,0-.353-.177-.309-.265l.265-1.546h.486l.132-.839h-.442l.088-.53h-.883s-.53,2.915-.53,3.268a.663.663,0,0,0,.706.751A1.356,1.356,0,0,0,182.881,223.886Z",
  transform: "translate(-172.371 -219.603)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7812",
  "data-name": "Path 7812",
  d: "M210.4,230.692a1.4,1.4,0,0,0,1.545,1.546,2.293,2.293,0,0,0,.927-.132l.177-.839a2.647,2.647,0,0,1-.927.221c-.971,0-.795-.707-.795-.707h1.81a5.727,5.727,0,0,0,.132-.795,1.2,1.2,0,0,0-1.281-1.281C211.062,228.616,210.4,229.588,210.4,230.692Zm1.545-1.281c.486,0,.4.574.4.618h-.971C211.371,229.985,211.46,229.411,211.945,229.411Z",
  transform: "translate(-199.582 -227.821)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7813",
  "data-name": "Path 7813",
  d: "M298.429,217.083l.177-.972a2.169,2.169,0,0,1-.751.221c-.618,0-.883-.486-.883-1.016,0-1.06.53-1.634,1.148-1.634a1.475,1.475,0,0,1,.795.265l.132-.927a3.1,3.1,0,0,0-1.016-.221c-1.016,0-2.031.883-2.031,2.561,0,1.1.53,1.855,1.59,1.855A3.961,3.961,0,0,0,298.429,217.083Z",
  transform: "translate(-280.457 -212.8)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7814",
  "data-name": "Path 7814",
  d: "M88.078,227.2a3.126,3.126,0,0,0-1.06.177l-.132.751a2.611,2.611,0,0,1,.971-.177c.309,0,.574.044.574.309,0,.177-.044.221-.044.221h-.4c-.751,0-1.59.309-1.59,1.325,0,.795.53.971.839.971a1.327,1.327,0,0,0,.927-.4l-.044.353h.795l.353-2.429A1.047,1.047,0,0,0,88.078,227.2Zm.177,1.987c0,.132-.088.839-.618.839a.345.345,0,0,1-.353-.353c0-.221.132-.53.795-.53A.7.7,0,0,0,88.255,229.187Z",
  transform: "translate(-82.426 -226.405)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7815",
  "data-name": "Path 7815",
  d: "M136.216,230.021a1.132,1.132,0,0,0,1.325-1.148c0-1.1-1.06-.883-1.06-1.325,0-.221.177-.309.486-.309.132,0,.618.044.618.044l.132-.795a3.353,3.353,0,0,0-.839-.088c-.662,0-1.325.265-1.325,1.148,0,1.016,1.1.927,1.1,1.325,0,.265-.309.309-.53.309a2.887,2.887,0,0,1-.795-.132l-.133.795C135.244,229.933,135.465,230.021,136.216,230.021Z",
  transform: "translate(-128.532 -225.649)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7816",
  "data-name": "Path 7816",
  d: "M429.717,214.4l-.177,1.192a1.224,1.224,0,0,0-.839-.442c-.795,0-1.5.971-1.5,2.12,0,.707.353,1.457,1.1,1.457a1.178,1.178,0,0,0,.839-.353l-.044.309h.883l.662-4.239Zm-.4,2.34c0,.486-.221,1.1-.706,1.1-.309,0-.486-.265-.486-.706,0-.707.309-1.148.707-1.148C429.143,215.99,429.319,216.211,429.319,216.74Z",
  transform: "translate(-404.415 -214.312)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7817",
  "data-name": "Path 7817",
  d: "M15.239,218.639l.53-3.18.088,3.18h.618l1.148-3.18-.486,3.18h.927l.707-4.239H17.314l-.883,2.605-.044-2.605H15.106l-.706,4.239Z",
  transform: "translate(-14.4 -214.312)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7818",
  "data-name": "Path 7818",
  d: "M260.971,232.244c.265-1.457.309-2.65.927-2.429a3.466,3.466,0,0,1,.309-1.016h-.177c-.4,0-.707.53-.707.53l.088-.486h-.839L260,232.289h.971Z",
  transform: "translate(-246.444 -227.917)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7819",
  "data-name": "Path 7819",
  d: "M348.078,227.2a3.126,3.126,0,0,0-1.06.177l-.132.751a2.61,2.61,0,0,1,.971-.177c.309,0,.574.044.574.309,0,.177-.044.221-.044.221h-.4c-.751,0-1.59.309-1.59,1.325,0,.795.53.971.839.971a1.327,1.327,0,0,0,.927-.4l-.044.353h.795l.353-2.429A1.031,1.031,0,0,0,348.078,227.2Zm.221,1.987c0,.132-.088.839-.618.839a.345.345,0,0,1-.353-.353c0-.221.132-.53.795-.53C348.255,229.187,348.255,229.187,348.3,229.187Z",
  transform: "translate(-328.075 -226.405)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7820",
  "data-name": "Path 7820",
  d: "M395.371,232.244c.265-1.457.309-2.65.927-2.429a3.468,3.468,0,0,1,.309-1.016h-.177c-.4,0-.706.53-.706.53l.088-.486h-.839l-.574,3.444h.971Z",
  transform: "translate(-373.426 -227.917)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_8629",
  "data-name": "Group 8629",
  transform: "translate(0.795 6.182)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_7821",
  "data-name": "Path 7821",
  d: "M180,223.268a.663.663,0,0,0,.706.751,1.681,1.681,0,0,0,.662-.132l.133-.751a1.917,1.917,0,0,1-.221.044c-.309,0-.353-.177-.309-.265l.265-1.546h.486l.132-.839h-.442l.088-.53",
  transform: "translate(-170.86 -219.603)",
  fill: "#dce5e5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7822",
  "data-name": "Path 7822",
  d: "M218.4,230.692c0,1.236.4,1.546,1.1,1.546a2.293,2.293,0,0,0,.927-.132l.177-.839a2.646,2.646,0,0,1-.927.221c-.971,0-.795-.707-.795-.707h1.81a5.727,5.727,0,0,0,.132-.795,1.2,1.2,0,0,0-1.28-1.281C218.621,228.616,218.4,229.588,218.4,230.692Zm1.1-1.281c.486,0,.574.574.574.618H218.93C218.93,229.985,219.018,229.411,219.5,229.411Z",
  transform: "translate(-207.14 -227.821)",
  fill: "#dce5e5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7823",
  "data-name": "Path 7823",
  d: "M305.987,217.083l.177-.972a2.17,2.17,0,0,1-.751.221c-.618,0-.883-.486-.883-1.016,0-1.06.53-1.634,1.148-1.634a1.475,1.475,0,0,1,.795.265l.132-.927a3.1,3.1,0,0,0-1.016-.221c-1.016,0-1.59.883-1.59,2.561,0,1.1.088,1.855,1.148,1.855A3.963,3.963,0,0,0,305.987,217.083Z",
  transform: "translate(-288.015 -212.8)",
  fill: "#dce5e5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7824",
  "data-name": "Path 7824",
  d: "M86.886,229.683a2.609,2.609,0,0,1,.971-.177c.309,0,.574.044.574.309,0,.177-.044.221-.044.221h-.4c-.751,0-1.59.309-1.59,1.325,0,.795.53.971.839.971a1.327,1.327,0,0,0,.927-.4l-.044.353h.795l.353-2.429c0-1.016-.883-1.06-1.236-1.06m.662,1.9a1.446,1.446,0,0,1-1.06.839.345.345,0,0,1-.353-.353c0-.221.132-.53.795-.53A3.607,3.607,0,0,0,88.7,230.7Z",
  transform: "translate(-82.426 -227.917)",
  fill: "#dce5e5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7825",
  "data-name": "Path 7825",
  d: "M136,229.933a3.737,3.737,0,0,0,1.016.088,1.132,1.132,0,0,0,1.325-1.148c0-1.1-1.06-.883-1.06-1.325,0-.221.177-.309.486-.309.132,0,.618.044.618.044l.132-.795a3.354,3.354,0,0,0-.839-.088c-.662,0-.883.265-.883,1.148,0,1.016.662.927.662,1.325,0,.265-.309.309-.53.309",
  transform: "translate(-129.288 -225.649)",
  fill: "#dce5e5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7826",
  "data-name": "Path 7826",
  d: "M437.044,216.348a1.224,1.224,0,0,0-.839-.442c-.795,0-1.06.971-1.06,2.12,0,.707-.088,1.457.662,1.457a1.179,1.179,0,0,0,.839-.353l-.044.309h.883l.662-4.239M437,217.5c0,.486-.4,1.1-.883,1.1-.309,0-.486-.265-.486-.707,0-.707.309-1.148.707-1.148A.675.675,0,0,1,437,217.5Z",
  transform: "translate(-411.919 -215.067)",
  fill: "#dce5e5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7827",
  "data-name": "Path 7827",
  d: "M15.239,218.639l.53-3.18.088,3.18h.618l1.148-3.18-.486,3.18h.927l.707-4.239h-1.1l-1.236,2.605-.044-2.605H15.9l-1.5,4.239Z",
  transform: "translate(-14.4 -214.312)",
  fill: "#dce5e5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7828",
  "data-name": "Path 7828",
  d: "M260.8,232.244h.927c.265-1.457.309-2.65.927-2.429a3.467,3.467,0,0,1,.309-1.016h-.177c-.4,0-.706.53-.706.53l.088-.486",
  transform: "translate(-247.2 -227.917)",
  fill: "#dce5e5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7829",
  "data-name": "Path 7829",
  d: "M346.886,229.683a2.609,2.609,0,0,1,.971-.177c.309,0,.574.044.574.309,0,.177-.044.221-.044.221h-.4c-.751,0-1.59.309-1.59,1.325,0,.795.53.971.839.971a1.327,1.327,0,0,0,.927-.4l-.044.353h.795l.353-2.429c0-1.016-.883-1.06-1.236-1.06m.662,1.9a1.446,1.446,0,0,1-1.06.839.345.345,0,0,1-.353-.353c0-.221.133-.53.795-.53A3.886,3.886,0,0,0,348.7,230.7Z",
  transform: "translate(-328.075 -227.917)",
  fill: "#dce5e5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7830",
  "data-name": "Path 7830",
  d: "M395.2,232.244h.927c.265-1.457.309-2.65.927-2.429a3.463,3.463,0,0,1,.309-1.016h-.177c-.4,0-.707.53-.707.53l.088-.486",
  transform: "translate(-374.182 -227.917)",
  fill: "#dce5e5"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "visa",
  transform: "translate(31.919 0.001)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_7831",
  "data-name": "Path 7831",
  d: "M184.8,196.13l2.8-15.73h4.369l-2.709,15.73Z",
  transform: "translate(-164.616 -179.876)",
  fill: "#3c58bf"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7832",
  "data-name": "Path 7832",
  d: "M184.8,196.13l3.582-15.73h3.583l-2.709,15.73Z",
  transform: "translate(-164.616 -179.876)",
  fill: "#293688"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7833",
  "data-name": "Path 7833",
  d: "M261.369,176.3a11.081,11.081,0,0,0-4.019-.7c-4.369,0-7.515,2.185-7.515,5.331,0,2.359,2.185,3.583,3.932,4.369s2.272,1.311,2.272,2.01c0,1.049-1.4,1.573-2.621,1.573a9.5,9.5,0,0,1-4.194-.874l-.612-.262L248,191.33a14.167,14.167,0,0,0,4.981.874c4.631,0,7.689-2.185,7.689-5.506,0-1.835-1.136-3.233-3.757-4.369-1.573-.786-2.534-1.223-2.534-2.01,0-.7.786-1.4,2.534-1.4a8.012,8.012,0,0,1,3.32.612l.437.175.7-3.408Z",
  transform: "translate(-220.913 -175.6)",
  fill: "#3c58bf"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7834",
  "data-name": "Path 7834",
  d: "M261.369,176.3a11.081,11.081,0,0,0-4.019-.7c-4.369,0-6.728,2.185-6.728,5.331,0,2.359,1.4,3.583,3.146,4.369s2.272,1.311,2.272,2.01c0,1.049-1.4,1.573-2.621,1.573a9.5,9.5,0,0,1-4.194-.874l-.612-.262L248,191.33a14.167,14.167,0,0,0,4.981.874c4.631,0,7.689-2.185,7.689-5.506,0-1.835-1.136-3.233-3.757-4.369-1.573-.786-2.534-1.223-2.534-2.01,0-.7.786-1.4,2.534-1.4a8.012,8.012,0,0,1,3.32.612l.437.175.7-3.408Z",
  transform: "translate(-220.913 -175.6)",
  fill: "#293688"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7835",
  "data-name": "Path 7835",
  d: "M367.225,180.4c-1.048,0-1.835.087-2.272,1.136L358.4,196.13h4.718l.874-2.622h5.592l.524,2.622H374.3l-3.67-15.73Zm-2.01,10.487c.262-.787,1.747-4.632,1.747-4.632s.35-.961.612-1.573l.262,1.486s.874,3.932,1.049,4.806h-3.67Z",
  transform: "translate(-319.255 -179.876)",
  fill: "#3c58bf"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7836",
  "data-name": "Path 7836",
  d: "M368.274,180.4c-1.049,0-1.835.087-2.272,1.136l-7.6,14.594h4.719l.874-2.622h5.592l.524,2.622H374.3l-3.67-15.73Zm-3.058,10.487c.349-.874,1.747-4.632,1.747-4.632s.35-.961.612-1.573l.262,1.486s.874,3.932,1.049,4.806h-3.67Z",
  transform: "translate(-319.255 -179.876)",
  fill: "#293688"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7837",
  "data-name": "Path 7837",
  d: "M57.753,192.124l-.437-2.272a12.667,12.667,0,0,0-6.116-6.9l3.932,13.982H59.85l7.078-15.73H62.21Z",
  transform: "translate(-45.608 -180.588)",
  fill: "#3c58bf"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7838",
  "data-name": "Path 7838",
  d: "M57.753,192.124l-.437-2.272a12.667,12.667,0,0,0-6.116-6.9l3.932,13.982H59.85l7.078-15.73H63.083Z",
  transform: "translate(-45.608 -180.588)",
  fill: "#293688"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7839",
  "data-name": "Path 7839",
  d: "M0,180.4l.786.175c5.592,1.311,9.437,4.632,10.922,8.564l-1.573-7.428c-.262-1.049-1.049-1.311-2.01-1.311Z",
  transform: "translate(0 -179.876)",
  fill: "#ffbc00"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7840",
  "data-name": "Path 7840",
  d: "M0,180.4H0c5.592,1.311,10.223,4.719,11.709,8.651l-1.485-6.2a2.133,2.133,0,0,0-2.1-1.66Z",
  transform: "translate(0 -179.876)",
  fill: "#f7981d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7841",
  "data-name": "Path 7841",
  d: "M0,180.4H0c5.592,1.311,10.223,4.719,11.709,8.651l-1.049-3.408a3.082,3.082,0,0,0-1.835-2.534Z",
  transform: "translate(0 -179.876)",
  fill: "#ed7c00"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_8630",
  "data-name": "Group 8630",
  transform: "translate(5.68 2.272)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_7842",
  "data-name": "Path 7842",
  d: "M62.835,205.139l-2.971-2.971-1.4,3.321-.35-2.185A12.667,12.667,0,0,0,52,196.4l3.932,13.982H60.65Z",
  transform: "translate(-52 -196.4)",
  fill: "#051244"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7843",
  "data-name": "Path 7843",
  d: "M189.256,293.045,185.5,289.2l-.7,3.845Z",
  transform: "translate(-170.295 -279.063)",
  fill: "#051244"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7844",
  "data-name": "Path 7844",
  d: "M255.6,274.8h0c.349.35.524.612.437.961,0,1.049-1.4,1.573-2.621,1.573a9.5,9.5,0,0,1-4.194-.874l-.612-.262L248,279.781a14.168,14.168,0,0,0,4.981.874c2.8,0,5.068-.787,6.379-2.185Z",
  transform: "translate(-226.592 -266.236)",
  fill: "#051244"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7845",
  "data-name": "Path 7845",
  d: "M364,231.048h4.107l.874-2.622h5.592l.524,2.622h4.194l-1.486-6.379-5.243-5.068.262,1.4s.874,3.932,1.049,4.806H370.2c.35-.874,1.748-4.632,1.748-4.632s.35-.961.612-1.573",
  transform: "translate(-329.922 -217.066)",
  fill: "#051244"
})));

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_29_1",
    "data-name": "Component 29 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.967,
    height: 16.692,
    viewBox: "0 0 86.967 16.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.3414258e.svg";
export { ForwardRef as ReactComponent };